import apiClient from './apiClient';

export interface AdminData {
  id: number;
  name: string;
  email: string;
  company_name?: string;
  phone?: string;
  status: 'active' | 'blocked' | 'super';
  created_at: string;
  subscriptions?: AdminSubscription[];
}

export interface AdminSubscription {
  id: number;
  admin_id: number;
  plan_id: number;
  expiration_date: string;
  status: 'active' | 'expired' | 'canceled';
  plan?: SubscriptionPlan;
}

export interface SubscriptionPlan {
  id: number;
  name: string;
  plan_type: 'basic' | 'professional' | 'enterprise';
  description?: string;
  price?: number;
}

export interface UpdateAdminData {
  name?: string;
  company_name?: string;
  phone?: string;
}

export interface ChangePasswordData {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

class AdminService {
  private baseURL = '/admin';

  /**
   * Obter dados do admin atual
   */
  async getCurrentAdmin(): Promise<AdminData> {
    try {
      const response = await apiClient.get(`${this.baseURL}/current`);
      return response.data.data;
    } catch (error: any) {
      const backendMessage =
        error.response?.data?.message ||
        error.response?.data?.error;
      throw new Error(backendMessage || 'Erro ao obter dados do admin');
    }
  }

  /**
   * Atualizar dados do admin atual
   */
  async updateCurrentAdmin(data: UpdateAdminData): Promise<AdminData> {
    try {
      const response = await apiClient.put(`${this.baseURL}/current`, data);
      return response.data.data;
    } catch (error: any) {
      const backendMessage =
        error.response?.data?.message ||
        error.response?.data?.error;
      throw new Error(backendMessage || 'Erro ao atualizar dados do admin');
    }
  }

  /**
   * Alterar senha do admin atual
   */
  async changePassword(data: ChangePasswordData): Promise<void> {
    try {
      await apiClient.put(`${this.baseURL}/current/password`, data);
    } catch (error: any) {
      const backendMessage =
        error.response?.data?.message ||
        error.response?.data?.error;
      throw new Error(backendMessage || 'Erro ao alterar senha');
    }
  }
}

export const adminService = new AdminService();